import { DossierQueryParams } from "../../../../../lib/api/resources/dossiers";
import { DossierFilterValues } from "../types/DossierFilterValues.interface";

export const buildDossierApiFilters = (
  filterValues: DossierFilterValues,
): Partial<DossierQueryParams> => {
  const apiFilters: Partial<DossierQueryParams> = {};

  if (filterValues.licenseplate) {
    apiFilters["vehicle.licensePlate.identifier"] = filterValues.licenseplate;
  }
  if (filterValues.expression) {
    apiFilters["expression"] = filterValues.expression;
  }
  if (filterValues.drivername) {
    apiFilters["driver.person.fullName"] = filterValues.drivername;
  }
  if (filterValues.insurerName) {
    apiFilters.insurerName = filterValues.insurerName;
    apiFilters["insuranceCompany.name"] = filterValues.insurerName;
  }
  if (filterValues.leaseCompanyName) {
    apiFilters["leaseCompany.name"] = filterValues.leaseCompanyName;
  }
  if (filterValues.externalReference) {
    apiFilters["fleetRecord.fleetClient.externalReference"] =
      filterValues.externalReference;
  }
  if (filterValues.servicePartnerId) {
    apiFilters["dossierServicePartners.servicePartner.id"] =
      filterValues.servicePartnerId;
  }
  if (
    filterValues.preferredServicePartner === true ||
    filterValues.preferredServicePartner === "true"
  ) {
    apiFilters.preferredServicePartner = true;
  }
  if (filterValues.dossierType) {
    apiFilters.dossierType = filterValues.dossierType;
  }

  if (filterValues.archived === true || filterValues.archived === "true") {
    apiFilters["exists[archivedAt]"] = true;
  } else {
    apiFilters["exists[archivedAt]"] = false;
  }

  return apiFilters;
};
